import { render, staticRenderFns } from "./SelectProductService.vue?vue&type=template&id=66ab33cf&"
import script from "./SelectProductService.vue?vue&type=script&lang=ts&"
export * from "./SelectProductService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ab33cf')) {
      api.createRecord('66ab33cf', component.options)
    } else {
      api.reload('66ab33cf', component.options)
    }
    module.hot.accept("./SelectProductService.vue?vue&type=template&id=66ab33cf&", function () {
      api.rerender('66ab33cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SalesOrder/SelectProductService.vue"
export default component.exports